export default __webpack_public_path__ + "static/media/NIAS0570.34I-40565_-23984_0.bf27135f.jpg";